module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="sections">\r\n    <h2>Help sections</h2>\r\n    <div class="list-group">\r\n        <a href="#help-physician" class="list-group-item"><b>Physician</b></a>\r\n        <a href="#help-office-admin" class="list-group-item"><b>Office Administrator</b></a>\r\n        <a href="#help-corporate-admin" class="list-group-item"><b>Corporate Administrator</b></a>\r\n        <a href="#help-feedback" class="list-group-item"><b>Feedback</b></a>\r\n    </div>\r\n</div>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/help/help-sections-list.html
// module id = 501
// module chunks = 0